import React from 'react';
import { Link } from 'react-router-dom';
import * as ROUTES from '../../../constants/routes';
import { categoryLabel } from '../ResourcesPage/resourcesData';
import { authorName, estimateReadTime } from './articleHelpers';

const BackIcon = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6" /></svg>;
const AuthorIcon = () => <svg viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" /><circle cx="12" cy="7" r="4" /></svg>;

const ArticleHeroBanner = ({ post }) => (
    <section className="lp-article-hero" style={{ backgroundImage: `url(${post.bannerImage || post.image})` }}>
        <div className="overlay" />
        <div className="content">
            <Link to={ROUTES.BLOGS} className="back"><BackIcon />Back to Resources</Link>

            <div className="tags">
                {(post.category || []).slice(0, 2).map((c, i) => <span key={i}>{categoryLabel(c)}</span>)}
            </div>

            <h1>{post.title}</h1>

            <div className="meta">
                <span className="author">
                    <span className="avatar"><AuthorIcon /></span>
                    {authorName(post)}
                </span>
                <span className="sep">·</span>
                <span>{post.date}</span>
                <span className="sep">·</span>
                <span>{estimateReadTime(post.postData)} min read</span>
            </div>
        </div>
    </section>
);

export default ArticleHeroBanner;
